import { useState } from "react";
import emailjs from "emailjs-com";
import React from "react";
import {useTranslation} from "react-i18next";

const initialState = {
  name: "",
  email: "",
  number: "",
  company: "",
  message: "",
};
export const Contact = () => {
  const [state, setState] = useState(initialState);
  const [sendMsg, setSendMsg] = useState(false);
  const { t } = useTranslation();
  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const clearState = () => setState(initialState);

  const success = () => {
    return (
        <div className="alert alert-success alert-dismissible">
          <a href="#" onClick={closeMsg} className="close" data-dismiss="alert" aria-label="close">&times;</a>
          {t('contact.msg')}.
        </div>
    )
  }

  const closeMsg = () => {
    setSendMsg(false);
  }


  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
        .sendForm("service_tel441n", "template_gw2eaak", e.target, "_48viSih2yPJL3CqP")
        .then(
            (result) => {
              if (result.text === 'OK') {
                setSendMsg(true)
                clearState();
          }
        },
        (error) => {
          console.log(error.text);
        }
      );
  };
  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8 col-xs-offset-1 col-sm-offset-0 col-xs-10">
            <div className="row">
              <div className="section-title">
                <h2>{t('contact.contactUs')}</h2>
              </div>
              <form name="sentMessage" validate onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <input
                          type="text"
                          id="name"
                          name="name"
                          className="form-control"
                          placeholder={t('contact.name')}
                          required
                          value={state.name}
                          autoComplete="off"
                          onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <input
                          type="email"
                          id="email"
                          name="email"
                          className="form-control"
                          placeholder={t('contact.email')}
                          required
                          value={state.email}
                          autoComplete="off"
                          onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <input
                          type="number"
                          id="number"
                          name="number"
                          className="form-control"
                          placeholder={t('contact.number')}
                          required
                          value={state.number}
                          autoComplete="off"
                          onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <input
                          type="text"
                          id="company"
                          name="company"
                          className="form-control"
                          placeholder={t('contact.company')}
                          autoComplete="off"
                          value={state.company}
                          onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-8">
                    <div className="form-group">
                    <textarea
                        name="message"
                        id="message"
                        className="form-control"
                        rows="1"
                        placeholder={t('contact.message')}
                        required
                        value={state.message}
                        onChange={handleChange}
                    ></textarea>
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div id="success">
                  {sendMsg && success()}
                </div>
                <button type="submit" className="btn btn-custom btn-lg" disabled={sendMsg}>
                  {t('contact.sendMsg')}
                </button>
              </form>
            </div>
          </div>
        </div>
        <div className='row footer-content'>
          <div className='container'>
            <div className="col-sm-2 col-xs-12 contact-info footer-logo">
              <p>
                <a className="page-scroll" href="#page-top">
                  <img src="img/footerLogo.png" alt="footer-logo"/>
                </a>
              </p>
            </div>
            <div className="col-sm-3 col-sm-offset-3 col-xs-12 contact-info">
              <p>{t('contact.contactUs')}</p>
              <p>
                <img src="img/u_envelope.png" alt="envelope"/>
                <span>
                <a href="mailto:info@profroad.am">info@profroad.am</a>
              </span>
              </p>
              <p>
                <img src="img/u_phone.png" alt="phone"/>
                <span>
                <a href="tel:+374 96 091 091">+374 96 091 091 </a>
              </span>
              </p>
              <p>
               <span className="fb_icon">
                <a href="https://www.facebook.com/asfaltapatum/" target="_blank">
                  <img src="img/u_facebook-f.png" alt="facebook"/>
                </a>
              </span>
                <span>
                <a href="#">
                  <img src="img/u_instagram.png" alt="instagram"/>
                </a>
              </span>
                <span className="youtube_share">
                <a href="https://www.youtube.com/@ProfRoad" target="_blank">
                  <img src="img/youtube.png" alt="youtube"/>
                </a>
              </span>
              </p>
            </div>
            <div className="col-sm-3 col-sm-offset-1 col-xs-12 contact-info">
              <p>
              <span>
               <a href="#about" className="page-scroll">
                {t('about.title')}
              </a>
              </span>
              </p>
              <p>
              <span>
               <a href="#partners" className="page-scroll">
                {t('partners.title')}
              </a>
              </span>
              </p>
              <p>
              <span>
              <a href="#media" className="page-scroll">
                {t('media.title')}
              </a>
              </span>
              </p>
              <p>
              <span>
               <a href="#contact" className="page-scroll">
                {t('contact.title')}
              </a>
              </span>
              </p>
            </div>
          </div>
        </div>
        <div id="footer">
          <div className="container text-center">
            <p>
              ProfRoad 2024. {t('contact.rights')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
